import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Table, Button, Flex, notification } from "antd";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import PageListActionBar from "../../../components/layout/page.actionBar";
import { useNavigate } from "react-router-dom";
import SelectField, { SelectionMode } from "./select";
import { deleteCourseById } from "../../../services";
import { coursesTableColumns } from "./table.columns";

export default function CpdCourseListPage({ loading, listItems, refetch }) {
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(15);
  const [selectFieldValue, setSelectFieldValue] = useState(null);

  const [notificationApi, notificationCtxHolder] =
    notification.useNotification();

  const handleRefreshPage = () => {
    setSelectFieldValue(null)
    refetch();
  };

  const handleRefresh = useCallback(() => refetch(), [refetch]);

  useEffect(() => {
    handleRefresh();
  }, [listItems, handleRefresh]);

  useEffect(() => setPageSize(pageSize), [pageSize]);

  const paginationConfig = {
    pageSize: pageSize,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} courses`,
    // showSizeChanger: true,
  };

  const handleView = (course) => {
    if (course) {
      navigate(`/manage/cpd/courses/${course?.uid}/details`);
    }
  };

  const handleAddCourse = () => {
    navigate(`/manage/cpd/courses/add-new-course`);
  };

  const handleDelete = (course) => {
    // deleting only one course
    deleteCourseById(course?.uid)
      .then((response) => {
        refetch();
        notification.success({
          message: `${course?.title} deleted successfully`,
        });
      })
      .finally(() => {});
  };

  const handleSelectChange = (value) => {
    setSelectFieldValue(value);
  };

  // Dynamically load options from listItems
  const selectOptions = useMemo(() => {
    // Only show options if listItems are loaded
    if (!listItems || !Array.isArray(listItems)) return [];
    return listItems?.map((item) => ({
      label: item.title,
      value: item.uid,
      desc: item.title,
    }));
  }, [listItems]);

  return (
    <React.Fragment>
      {notificationCtxHolder}
      <PageListActionBar
        leftElement={() => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <SelectField
              onSelectOptionChange={handleSelectChange}
              options={selectOptions}
              maxCount={1}
              mode={SelectionMode.MULTIPLE}
              value={selectFieldValue}
            />
            <Button
              title="Refresh"
              onClick={handleRefreshPage}
              icon={<ReloadOutlined />}
              size="middle"
              type="dashed"
            />
          </div>
        )}
        rightElement={() => (
          <Flex wrap gap="small">
            <Button
              type="dashed"
              onClick={handleAddCourse}
              icon={<PlusOutlined />}
            >
              Add Course
            </Button>
          </Flex>
        )}
      />
      <Table
        loading={loading}
        columns={coursesTableColumns({
          handleView,
          handleDelete,
          notificationApi,
        })}
        dataSource={
          selectFieldValue?.length > 0
            ? listItems.filter((item) => selectFieldValue.includes(item.uid))
            : listItems
        }
        rowKey="uid"
        // rowSelection={rowSelectionConfig}
        pagination={paginationConfig}
        showSorterTooltip={{ target: "sorter-icon" }}
      />
    </React.Fragment>
  );
}
